import React from "react";

interface ShiftChipProps {
	shift: string;
	size?: "small" | "medium" | "large";
}

export const ShiftChip: React.FC<ShiftChipProps> = ({
	shift,
	size = "medium",
}) => {
	const getSizeStyles = () => {
		switch (size) {
			case "small":
				return {
					padding: "2px 6px",
					fontSize: "0.75rem",
					minWidth: "20px",
					height: "20px",
				};
			case "large":
				return {
					padding: "4px 12px",
					fontSize: "0.875rem",
					minWidth: "32px",
					height: "32px",
				};
			default: // medium
				return {
					padding: "4px 8px",
					fontSize: "0.8125rem",
					minWidth: "24px",
					height: "24px",
				};
		}
	};

	const baseStyles: React.CSSProperties = {
		display: "inline-flex",
		alignItems: "center",
		justifyContent: "center",
		borderRadius: "4px",
		fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
		lineHeight: "1.5",
		cursor: "default",
		fontWeight: 800,
		color: "rgb(255, 255, 255)",
		...getSizeStyles(),
	};

	const getShiftStyles = (shiftValue: string): React.CSSProperties => {
		switch (shiftValue) {
			case "D":
				return {
					backgroundColor: "#DDD116",
					border: "1px solid rgb(224, 208, 101)",
				};
			case "N":
				return {
					backgroundColor: "rgb(161, 66, 221)",
					border: "1px solid rgb(183, 102, 233)",
				};
			default:
				return {
					backgroundColor: "#6c757d",
					border: "1px solid #6c757d",
				};
		}
	};

	return <div style={{ ...baseStyles, ...getShiftStyles(shift) }}>{shift}</div>;
};
